import React from 'react';

export interface HistoryContextType {
  lastVisitedListPage: string;
}

export default React.createContext<HistoryContextType>({
  lastVisitedListPage: null,
});
